import type { AdminListUsersParams } from '../api'
import adminUserService from './admin-user.service'
import { EAdminUserQueryKey } from './admin-user.types'

export const adminListUsersOptions = (
  params: Omit<AdminListUsersParams, 'userType'> & {
    userType?: 'user' | 'agent'
  },
) => {
  return {
    queryKey: [EAdminUserQueryKey.ADMIN_USERS, params],
    queryFn: () =>
      adminUserService.adminListUsers(params as AdminListUsersParams),
  }
}
